/**
 * HQ 점포별 매출 서비스. (대표 전용 — 백엔드에서 hq_admin 게이트)
 * 가맹점 자체 매출(이용권 판매, 취소 제외) 집계.
 */
import hqApi from './hqApiClient';

export interface StoreRevenue {
  organization_id: string;
  name: string;
  this_month: number;
  this_month_count: number;
  last_month: number;
  cumulative: number;
}

export interface RevenueByStore {
  month: string;        // YYYY-MM
  prev_month: string;   // YYYY-MM
  stores: StoreRevenue[];
  totals: { this_month: number; last_month: number; cumulative: number };
  note: string;
}

export interface StoreMonthlyPoint {
  month: string; // YYYY-MM
  amount: number;
  count: number;
}

export interface StoreMonthly {
  organization_id: string;
  name: string;
  series: StoreMonthlyPoint[];
}

export const hqRevenueService = {
  async byStore(month?: string): Promise<RevenueByStore> {
    const { data } = await hqApi.get<RevenueByStore>('/api/v1/hq/revenue/by-store', {
      params: month ? { month } : undefined,
    });
    return data;
  },

  async storeMonthly(organizationId: string, months = 6): Promise<StoreMonthly> {
    const { data } = await hqApi.get<StoreMonthly>(
      `/api/v1/hq/revenue/store/${organizationId}/monthly`,
      { params: { months } },
    );
    return data;
  },
};
